const ENDPOINT = 'POSTvalidatemailtoken';
function postValidateEmailToken(gateway, params = {}) {
    return gateway.post(postValidateEmailToken.endpoint, params, params);
}
postValidateEmailToken.endpoint = ENDPOINT;

export { postValidateEmailToken as default };
//# sourceMappingURL=postValidateEmailToken.js.map
